module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Info.3fec9e48.svg";